import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '@components/sec_breadcrumb/component';
import ProductMetadata from '../_product-metadata/component';
import { Rating, Metabar } from 'audamatic-ui';
import TypeSet from '@components/base_typeset/component';
import Link from '@components/base_link/component';
import WishlistToggle from '@components/ui_wishlist_toggle/component';
import HistoryToggle from '@components/ui_history_toggle/component';
import Text from '@text';
import StockCounter from '@components/stock_counter/component';
import { IS_B2B } from '@config';

import './styles.scss';

const ProductHeader = ({ product, store, reviewCount }) => {
  const { sku } = product;

  const handleClickReviewSection = () => {
    const section = document.querySelector('#section-reviews');
    section.scrollIntoView();
  };

  return (
    <div className="product-detail-header">
      <div>
        <Breadcrumb items={product.breadcrumb} store={store}/>
        <ProductMetadata product={product} store={store}/>
        {!product.isGiftcard && (
          <div className="product-meta-description">
              <Metabar>
                {product.orderQuantity && (
                  <div>
                    <TypeSet bold>{product.orderQuantity} <Text>pdp.product.units</Text></TypeSet>
                  </div>
                )}
                {!!product.persons.length && (
                  <div className="text-base" data-test-id="pdpMetaPersons">
                    {product?.persons?.map((person, index) => (
                      <Fragment key={person.url}>
                        {!!index && ', '}
                        <Link href={person.url} data-test-id="author">{person.name}</Link>
                      </Fragment>
                    ))}
                  </div>
                )}
                {product.getProductLanguages() && <div>{product.getProductLanguages()}</div>}
                {IS_B2B && <div>{product.ean || product.sku}</div> }
                {IS_B2B && product.releaseDate && <div>{product.releaseDate}</div>}
                {product.pages && <div>{product.pages} <Text>pdp.product.pages</Text></div>}
                {product.duration && <div>{product.formatedDuration}</div>}
                {product.rating && (
                  <a className="review-section-link" onClick={() => handleClickReviewSection()}>
                    <Rating rating={product.rating}/>
                    <span className="review-count">
                      {!!reviewCount && (`(${reviewCount})`) }
                    </span>
                  </a>
                )}
                {!!product?.stockLevel && product?.stockLevel > 0 && !product.isCBProduct && !product.isCBBuitenlandsProduct &&  (
                  <StockCounter stockCount={product.stockLevel} />
                )}
                {IS_B2B && (
                  <div className="right-of-return"><Text>product.metadata.rightofreturn</Text>:&nbsp;
                    <TypeSet bold color="cta">
                      {!!product.rightOfReturn ? (
                        <Text>product.metadata.rightofreturn.yes</Text>
                      ) : (
                        <Text>product.metadata.rightofreturn.no</Text>
                      )}
                    </TypeSet>
                  </div>
                )}
              </Metabar>
          </div>
        )}
      </div>

      <div className="top-buttons">
        <WishlistToggle
          withoutContent={true}
          sku={sku}
          product={product}
          buttonType="fullSize"
          store={store}
          extraAttributes={{ 'data-test-id': 'button-addToWishlist' }}
        />
        <HistoryToggle
          product={product}
          size="large"
          isSingleProduct={true}
        />
      </div>
    </div>
  );
};

ProductHeader.propTypes = {
  store: PropTypes.object,
  product: PropTypes.object,
  reviewCount: PropTypes.number,
};

export default ProductHeader;
